import { readable, get } from "svelte/store";
import rawIcons from "../../public/df_assets/img/icons/icons.svg";

export const icons = readable({}, (set) => {
  let iconArray = [];

  rawIcons
    .replace(
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">',
      ""
    )
    .replace("</svg>", "")
    .split("</g>")
    .forEach((icon) => {
      let nameStart = 8,
        nameEnd = icon.indexOf(`">`);

      let o = {
        name: icon.substring(nameStart, nameEnd),
        g: `${icon.replace(` fill="black"`, "")}</g>`,
      };

      iconArray.push(o);
    });

  set(iconArray);
});
